import React from "react";
import "./style.css";

const ShowPhotos = ({ product, index, is_modalOpen, set_is_ModalOpen }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [modalImageIndex, setModalImageIndex] = React.useState(0);
  const [isImageLoading, setIsImageLoading] = React.useState(true);

  React.useEffect(() => {
    setModalImageIndex(index);
    setIsModalOpen(is_modalOpen);
    setIsImageLoading(true)
  }, [is_modalOpen]);

  const closeModal = () => {
    setIsModalOpen(false);
    set_is_ModalOpen(false);
  };

  const nextImage = () => {
    setIsImageLoading(true);
    setModalImageIndex((prevIndex) =>
      prevIndex === product.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setIsImageLoading(true);
    setModalImageIndex((prevIndex) =>
      prevIndex === 0 ? product.images.length - 1 : prevIndex - 1
    );
  };

  // Keyboard navigation for modal
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;

      if (e.key === "Escape") {
        closeModal();
      } else if (e.key === "ArrowRight") {
        nextImage();
      } else if (e.key === "ArrowLeft") {
        prevImage();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen]);

  return (
    <div>
      {/* Image Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">
                {product.name} - {modalImageIndex + 1} of{" "}
                {product.images.length}
              </div>
              <button className="modal-close" onClick={closeModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="modal-body">
              <div className="modal-sidebar">
                {product.images.map((image, index) => (
                  <img
                    key={index}
                    src={image.image_url}
                    alt={`Thumbnail ${index + 1}`}
                    className={`modal-thumbnail ${
                      modalImageIndex === index ? "active" : ""
                    }`}
                    onClick={() => setModalImageIndex(index)}
                  />
                ))}
              </div>

              <div className="modal-main-image">
                {isImageLoading && (
                  <div className="loader">
                    <div className="spinner"></div>
                    <div className="loader-text">Loading image...</div>
                  </div>
                )}
                <img
                  src={product.images[modalImageIndex].image_url}
                  alt={product.name}
                  className={`modal-image ${isImageLoading ? "loading" : ""}`}
                  onLoad={() => setIsImageLoading(false)}
                />

                <button
                  className="modal-navigation modal-prev"
                  onClick={prevImage}
                >
                  <i className="fas fa-chevron-left"></i>
                </button>

                <button
                  className="modal-navigation modal-next"
                  onClick={nextImage}
                >
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ShowPhotos;
